import http from '../utils/request'


//获取钉钉的部门信息
export const getDDdeptInfo = (data) => {

    return http.post("dd-dept/getDDdeptInfo", data)
}
